import { useMediaQuery, useTheme, Breakpoint } from '@mui/material';

const useBreakpoint = (mode: "up" | "down" | "only" | "not", breakpoint: Breakpoint) => {
    const theme = useTheme();
    const result = useMediaQuery(theme.breakpoints[mode](breakpoint));

  return result;
}

export default useBreakpoint;